import { Component, Vue } from 'vue-property-decorator';

import BrochureCard from '@/common/interfaces/modules/BrochureCard';
import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';
import { ImageWidths } from '@/common/interfaces/SizeBreakpoints';

import Pin from '@/assets/icons/pin-filled.svg?inline';
import CtaButton from '@/components/CtaButton/CtaButton.vue';

const BrochureCardProps = Vue.extend({
    props: { card: Object as () => BrochureCard },
});

@Component({
    components: {
        Pin,
        CtaButton,
    },
})
export default class BrochureDetailModule extends BrochureCardProps {
    imageWidths: ImageWidths = {
        def: 356,
        sizes: {
          sm: 356,
        },
    };
    get buttons() {
        const orderButton: CtaLinkItem = {
            Title: 'Request Brochure',
            Link: this.card.OrderLink,
            ButtonStyle: CtaButtonStyle.PrimaryDarkBlack,
        };
        const viewButton: CtaLinkItem = {
            Title: 'View online',
            Link: this.card.BrochureLink,
            ButtonStyle: CtaButtonStyle.White,
        };
        const pdfButton: CtaLinkItem = {
            Title: 'Download Brochure',
            Link: this.card.PdfLink,
            ButtonStyle: CtaButtonStyle.PrimaryDarkBlack,
        };

        return { orderButton, viewButton, pdfButton };
    }
    onDownloadClick($event: Event) {
        this.$emit('onDownloadClick', $event, this.card.PdfLink)
    }
}
